import React from "react";
import ReactFlagsSelect from "react-flags-select";
import styles from "./FlagsSelect.module.css";
const FlagsSelect = ({
  name,
  value,
  onChange,
  error,
  touched,
  required,
  label,
  placeholder,
  icon,
}) => {
  const handleSelect = (countryCode) => {
    onChange(name, countryCode);
  };

  return (
    <div className={styles.selectContainer}>
      {label ? (
        <label>
          {label} {required && <span className={styles.required}>*</span>}
        </label>
      ) : (
        ""
      )}
      <div
        className={`${styles.selectSubContainer} ${
          error && touched ? styles.error : styles.noerror
        }`}
      >
        {icon && <img src={icon} alt="icon" className={styles["icon"]} />}
        <ReactFlagsSelect
          placeholder={placeholder}
          selected={value}
          onSelect={(code) => handleSelect(code)}
          searchPlaceholder="Search for a country"
          searchable={true}
          className={styles["menu-flags"]}
        />
      </div>{" "}
    </div>
  );
};

export default FlagsSelect;
